import { BugIcon, ModalContent, modalContext, platformContext, ThumbsUpIcon } from "shared";
import React, { useContext, useMemo } from "react";
import { Platform } from "@yandex-int/hr-components/lib";
import { useLocation } from "react-router-dom";
import { useDebugPanelTranslations } from "../lib/i18n";
import styles from "./debug-panel.module.scss";

interface IDebugPanelProps {}

export const DebugPanel: React.FC<IDebugPanelProps> = ({}) => {
    const { close, openModal } = useContext(modalContext);
    const location = useLocation();
    const t = useDebugPanelTranslations();
    const platform = useContext(platformContext);
    const showRateButton = useMemo(() => {
        const path = location.pathname.split("/");
        return path[1] !== "iframe" && platform === Platform.DESKTOP;
    }, [location.pathname, platform]);

    const handleBugClick = () => {
        openModal(
            <ModalContent close={close}
                          showButtonGroup={false}
                          title={t('reportProblem')}>
                <div className={styles.bugForm}>
                    <iframe className={styles.bugIframe} src="https://forms.yandex-team.ru/ext/surveys/13681624?iframe=1"></iframe>
                </div>
            </ModalContent>
        );
    }

    return <div className={styles.debugPanel}>
        <div className={styles.list}>
            <div className={styles.listItem} onClick={handleBugClick}>
                <BugIcon title={t('reportProblem')}/>
            </div>
            {showRateButton && <a className={styles.thumbsUpItem}
               target="_blank"
               href="https://forms.yandex.ru/surveys/13764968.f0f0ce28488466a79f8075ed61ffd1fd5e608393/"
               rel="noopener noreferrer">
                <ThumbsUpIcon/>
                <div>{t("rate")}</div>
            </a>}
        </div>
    </div>;
}
